import { ElevenLabsClient } from "elevenlabs";

// ElevenLabs Credentials
const elevenLabsApiKey = process.env.REACT_APP_ELEVENLABS_API_KEY;
const client = new ElevenLabsClient({ apiKey: elevenLabsApiKey });

async function textToSpeech(
  text,
  elevenLabsVoiceId,
  elevenLabsLanguageCode,
  elevenLabsVoiceSettings,
  mappedPronunciation
) {
  return new Promise(async (resolve, reject) => {
    try {
      const startTime = performance.now();
      const audioBlob = await elevenLabsTextToSpeech(
        text,
        elevenLabsVoiceId,
        elevenLabsLanguageCode,
        elevenLabsVoiceSettings,
        mappedPronunciation
      );
      const duration = performance.now() - startTime;
      console.log(`TTS Time taken: ${duration} milliseconds`);
      resolve(audioBlob);
    } catch (error) {
      reject(error);
    }
  });
}

async function elevenLabsTextToSpeech(
  text,
  elevenLabsVoiceId,
  elevenLabsLanguageCode,
  elevenLabsVoiceSettings,
  mappedPronunciation
) {
  return new Promise(async (resolve, reject) => {
    let replacedText = text;
    if (mappedPronunciation !== undefined) {
      for (const [original, replacement] of Object.entries(
        mappedPronunciation
      )) {
        if (replacedText.includes(original)) {
          replacedText = replacedText.split(original).join(replacement);
        }
      }
    }

    try {
      const audioStream = await client.textToSpeech.convert(elevenLabsVoiceId, {
        output_format: "mp3_44100_128",
        text: replacedText,
        model_id: "eleven_flash_v2_5",
        language_code: elevenLabsLanguageCode,
        voice_settings: elevenLabsVoiceSettings,
      });

      // Convert to Blob
      const chunks = [];
      for await (const chunk of audioStream) {
        chunks.push(chunk);
      }

      const binaryData = new Uint8Array(
        chunks.reduce((acc, chunk) => acc + chunk.length, 0)
      );
      let offset = 0;
      for (const chunk of chunks) {
        binaryData.set(chunk, offset);
        offset += chunk.length;
      }

      const audioBlob = new Blob([binaryData], { type: "audio/mpeg" });

      resolve(audioBlob);
    } catch (error) {
      reject(error);
    }
  });
}

export default textToSpeech;
